<template>
  <div>
    <van-form>
      <van-field label="订单号">
        <template #input>
          <span style="margin-right: 15px">{{ form.order_no }}</span
          ><van-icon name="replay" @click="setAddress" />
        </template>
      </van-field>
      <van-field label="地址">
        <template #input>
          <span>{{ form.name }}，{{ form.mobile }}，{{ form.province }}{{ form.city }}{{ form.area }}{{ form.addr }}</span>
        </template>
      </van-field>
      <van-field label="支付金额">
        <template #input>
          <span>{{ form.allAmount }}元</span>
        </template>
      </van-field>
      <van-field label="毛收入">
        <template #input>
          <span>{{ form.allAmount- form.tradeFee }}元</span>
        </template>
      </van-field>
      <van-field label="主图">
        <template #input>
          <img v-for="item in form.items" :key="item.itemId" :src="item.imgUrl" style="width: 30%; height: 30%" />
        </template>
      </van-field>
      <van-field label="书本标题">
        <template #input>
          <span v-for="item in form.items"  :key="item.itemId" >{{ item.itemName }} X {{ item.number }}本</span>
        </template>
      </van-field>
      <van-field label="购买">
        <template #input>
          <a v-for="item in form.items"  :key="item.itemId"  style="color:#1989fa" @click="openUrl(item.kongfz_book_id, 3)">去购买商品</a>
        </template>
      </van-field>
      <van-field label="孔夫子订单号">
        <template #input>
          <van-field v-for="(item, index) in form.order_sons" :key="index" v-model="item.k_order" placeholder="输入孔夫子单号" />
          <van-icon name="add-o" @click="addSonOrder" />
        </template>
      </van-field>
      <van-field label="购买成本" v-model="form.costAmount" placeholder="输入购买成本(元)" />
      <van-field label="备注" v-model="form.remark" placeholder="备注" />
      <div style="margin: 16px">
        <van-button round block type="info" @click="updateOrder">保存</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      order_no: '',
      form: {
        order: ''
      }
    }
  },
  created() {
    console.log(this.$route.query.order_no)
    this.order_no = this.$route.query.order_no
    if (this.order_no) {
      this.getMyOrderDetail()
    }
  },
  methods: {
    openUrl(isbn, type) {
      if (type === 0) {
        window.open('https://search.kongfz.com/item_result/?key=' + isbn, '_blank')
      } else if (type === 2) {
        window.open('https://shop.kongfz.com/buyer/order/order_detail.html?orderId=' + isbn, '_blank')
      } else if (type === 3) {
        window.open('https://m.kongfz.com/item/' + isbn, '_blank')
      } else {
        window.open('https://www.goofish.pro/product/edit?product_id=' + isbn, '_blank')
      }
    },
    addSonOrder() {
      this.form.order_sons.push({
        k_order: ''
      })
    },
    async setAddress() {
      const { data: res } = await this.$http.get('assistant/order/editAddress?order_no=' + this.order_no)
      if (res.code === 200) {
        this.$toast(res.msg)
      }
    },
    async updateOrder() {
      const { data: res } = await this.$http.post('assistant/order/update', this.form)
      if (res.code === 200) {
        this.$toast(res.msg)
      }
    },
    async getMyOrderDetail() {
      const { data: res } = await this.$http.get('assistant/order/show?order_no=' + this.order_no)
      if (res.code === 200) {
        this.form = res.data
        if (this.form.order_sons.length === 0) {
          this.form.order_sons.push({
            k_order: ''
          })
        }
      }
    }
  },
  components: {}
}
</script>

<style scoped>
.header {
  background: #4a4a56;
  padding: 2rem;
  text-align: center;
}
.header div {
  text-align: center;
  color: #c2c4d4;
  font-size: 16px;
}
.van-image {
  width: 80%;
}
.text {
  color: #8d9da7;
  padding: 1rem;
}
.text_1 {
  color: #f10e0e;
  padding: 1rem;
}
.mod {
  margin: 1rem;
  text-align: center;
}
</style>
